;(()=>{
    
    


    htmx.config.globalViewTransitions = true;

    const DURATION = 0.3;
    const STAGGER = 0.0;
    const DELAY = 0.3

    const OUT_OP = 0.7

    window.addEventListener('htmx:beforeRequest',(e)=>{
        
        if(e?.detail?.pathInfo?.requestPath?.includes('?')){
            return;
        }
        gsap.to('[data-modal]',{
            x:(index, target) => exitState(index, target),
            opacity:0,
            duration:DURATION,
            stagger:STAGGER,
            delay:DELAY,
        })
        // gsap.to('[data-fade]', {
        //     opacity:OUT_OP,
        //     duration:0.5,
            
        // })
        // gsap.to('[data-viewport]',{opacity:0, duration:0.2})
    })
    window.addEventListener('htmx:afterSettle',(e)=>{        
        
        if(e?.detail?.pathInfo?.requestPath?.includes('?')){
            return;
        }
        gsap.fromTo('[data-modal]',{
            x:(index, target) => exitState(index, target),
            opacity:0,
            duration:DURATION,
            stagger:STAGGER
        },{
            x:0,
            opacity:1,
            duration:DURATION,
            stagger:STAGGER,
            delay:DELAY
        })

        

        // gsap.fromTo('[data-viewport]',{opacity:0, duration:0.2}, {opacity:1, duration:0.2})

    })

    // window.addEventListener('htmx:afterswap',(e) => {
    //     const fade = document.querySelector('[data-fade]')
    //     gsap.fromTo(fade, {
    //         opacity:OUT_OP,
            
    //     },{
    //         opacity:`${fade.dataset.op}%`,
    //         duration:0.3
    //     })
    // })

    window.addEventListener('htmx:error', (e) => {
        console.log("[target error]", e)
        if(e.target.href){
            document.location.href = e.target.href
        }else{
            document.location.href = '/'
        }
    })

})();

function exitState(index, target){
    return target.dataset.modal == 'right' ? '100%' : '-100%'
}